import { lazy } from 'react'
import { PATHS } from './paths'
import { Route } from '~/types'
import withBreadcrumbBar from '~/common/withBreadcrumbBar'

const LandingPage = lazy(() =>
  import(/* webpackChunkName: "LandingPage" */ '~/app/pages/LandingPage')
)

const NotFound = lazy(() => import(/* webpackChunkName: "NotFound" */ '~/app/pages/NotFound'))

const Error = lazy(() => import(/* webpackChunkName: "Error" */ '~/app/pages/Error'))

const Transactions = lazy(() =>
  import(/* webpackChunkName: "Transactions" */ '~/app/pages/Transactions')
)
const TransactionDetails = lazy(() =>
  import(/* webpackChunkName: "TransactionDetails" */ '~/app/pages/TransactionDetails')
)
const Deposit = lazy(() => import(/* webpackChunkName: "Deposit" */ '~/app/pages/Deposit'))
const DepositRequests = lazy(() =>
  import(/* webpackChunkName: "DepositRequests" */ '~/app/pages/DepositRequests')
)
const MyAccount = lazy(() => import(/* webpackChunkName: "MyAccount" */ '~/app/pages/MyAccount'))
const Withdraw = lazy(() => import(/* webpackChunkName: "Withdraw" */ '~/app/pages/Withdraw'))

const Verification = lazy(() =>
  import(/* webpackChunkName: "Verification" */ '~/app/pages/Verification')
)

const VerificationClaimKyc = lazy(() =>
  import(/* webpackChunkName: "VerificationClaimKyc" */ '~/app/pages/NewVerification/ClaimKyc')
)

const VerificationFlow = lazy(() =>
  import(/* webpackChunkName: "VerificationFlow" */ '~/app/pages/VerificationFlow')
)

const VerificationMyInfoCallback = lazy(() =>
  import(/* webpackChunkName: "NewVerification" */ '~/app/pages/NewVerification/MyInfoDetails')
)
const InternalTools = lazy(() =>
  import(/* webpackChunkName: "InternalTools" */ '~/app/pages/InternalTools')
)

const routes: Route[] = [
  {
    path: PATHS.LANDING_PAGE,
    component: LandingPage,
    exact: true,
    sideBar: 'Dashboard',
    breadcrumbName: 'Home',
  },
  {
    path: PATHS.TRANSACTIONS,
    component: withBreadcrumbBar(Transactions),
    exact: true,
    sideBar: 'Transactions',
    breadcrumbName: 'Transactions',
  },
  {
    path: PATHS.TRANSACTION_DETAILS,
    component: TransactionDetails,
    exact: true,
  },
  {
    path: PATHS.DEPOSIT,
    component: withBreadcrumbBar(Deposit),
    exact: true,
    breadcrumbName: 'Deposit',
  },
  {
    path: PATHS.DEPOSIT_REQUESTS,
    component: withBreadcrumbBar(DepositRequests),
    exact: true,
    breadcrumbName: 'Deposit Requests',
  },
  {
    path: PATHS.WITHDRAW,
    component: withBreadcrumbBar(Withdraw),
    exact: true,
    breadcrumbName: 'Withdraw',
  },
  {
    path: PATHS.MANAGE_ACCOUNT,
    component: withBreadcrumbBar(MyAccount),
    exact: true,
    breadcrumbName: 'My Account',
  },
  {
    path: PATHS.VERIFICATION,
    component: withBreadcrumbBar(Verification),
    exact: true,
    breadcrumbName: 'Verification',
  },
  {
    path: PATHS.VERIFICATION_FLOW,
    component: withBreadcrumbBar(VerificationFlow),
    exact: true,
  },
  {
    path: PATHS.CLAIM_KYC,
    component: withBreadcrumbBar(VerificationClaimKyc),
    exact: true,
    breadcrumbName: 'Verification',
  },
  {
    path: PATHS.VERIFICATION_MY_INFO_CALLBACK,
    component: withBreadcrumbBar(VerificationMyInfoCallback),
    breadcrumbName: 'Verification',
    exact: true,
  },
  {
    path: PATHS.INTERNAL_TOOLS,
    component: withBreadcrumbBar(InternalTools),
    breadcrumbName: 'Internal Tools',
  },
  {
    path: PATHS.ERROR,
    component: Error,
  },
  {
    component: NotFound,
  },
]

export default routes
